

































import { Component, Vue, Prop, Provide } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import ValidationService from "../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../inversify.config";
import { ResetPassword } from "../../models/authentication/reset-password.model";

const UserModule = namespace("userModule");

@Component({})
export default class ResetPasswordForm extends Vue {
  @UserModule.Action public resetPassword;

  @Prop([String])
  public token: string;
  @Prop([String])
  public emailaddress: string;

  @Provide()
  public resetPasswordModel: ResetPassword = new ResetPassword(
    this.emailaddress,
    this.token
  );

  private isBusy: boolean = false;

  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  private submitForm() {
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        this.isBusy = true;
        this.resetPassword(this.resetPasswordModel).then((result) =>
          this.processResetPasswordResult(result)
        );
      }
    });
  }
  private processResetPasswordResult(value) {
    if (value) {
      this.$router.push({
        name: "LoginPage"
      });
    }
  }
}
